import { type FC } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Divider } from '@vakantiesnl/components/src/atoms/Divider';
import { Link } from '@vakantiesnl/components/src/atoms/Link';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { type Adlinks as AdlinkTypes } from '@vakantiesnl/types';

import { useCustomStyles } from './AdlinkCell.style';

export interface AdlinkCellProps {
	/** Adlink to show */
	adlink: AdlinkTypes.FormattedAdlink;
}

export const AdlinkCell: FC<AdlinkCellProps> = ({ adlink }) => {
	const { classes } = useCustomStyles();

	return (
		<div>
			<Link
				href={adlink.to}
				className={classes.adlinkAnchor}
				target="_blank"
				rel="nofollow noreferrer"
				onClick={adlink.onClick}
			>
				<div className={classes.adlink}>
					<div className={classes.adlinkContent}>
						<Typography variant="bodySm" as="p" className={classes.adlinkName}>
							{adlink.text}
						</Typography>
						<img src={adlink.logo} alt={adlink.text} className={classes.adlinkImage} />
					</div>
					<Button
						type="button"
						aria-label={adlink.buttonText}
						className={classes.adlinkButton}
						leadingIcon="external"
						variant="tertiary"
						size="small"
					/>
				</div>
			</Link>
			<Divider noMargins={true} />
		</div>
	);
};
